"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AwsKmsSigner = void 0;
var _bytes = require("@ethersproject/bytes");
var _abstractSigner = require("@ethersproject/abstract-signer");
var _properties = require("@ethersproject/properties");
var _keccak = require("@ethersproject/keccak256");
var _transactions = require("@ethersproject/transactions");
var _hash = require("@ethersproject/hash");
var _awsKmsUtils = require("./util/aws-kms-utils");
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class AwsKmsSigner extends _abstractSigner.Signer {
  constructor(kmsCredentials, provider) {
    super();
    _defineProperty(this, "kmsCredentials", void 0);
    _defineProperty(this, "ethereumAddress", void 0);
    (0, _properties.defineReadOnly)(this, "provider", provider || null);
    (0, _properties.defineReadOnly)(this, "kmsCredentials", kmsCredentials);
  }
  getAddress() {
    var _this = this;
    return _asyncToGenerator(function* () {
      if (_this.ethereumAddress === undefined) {
        const key = yield (0, _awsKmsUtils.getPublicKey)(_this.kmsCredentials);
        _this.ethereumAddress = (0, _awsKmsUtils.getEthereumAddress)(Buffer.from(key.PublicKey));
      }
      return Promise.resolve(_this.ethereumAddress);
    })();
  }
  _signDigest(digestString) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      const digestBuffer = Buffer.from((0, _bytes.arrayify)(digestString));
      const sig = yield (0, _awsKmsUtils.requestKmsSignature)(digestBuffer, _this2.kmsCredentials);
      const ethAddr = yield _this2.getAddress();
      const _determineCorrectV = (0, _awsKmsUtils.determineCorrectV)(digestBuffer, sig.r, sig.s, ethAddr),
        v = _determineCorrectV.v;
      return (0, _bytes.joinSignature)({
        v,
        r: `0x${sig.r.toString("hex")}`,
        s: `0x${sig.s.toString("hex")}`
      });
    })();
  }
  signMessage(message) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      return _this3._signDigest((0, _hash.hashMessage)(message));
    })();
  }
  signTransaction(transaction) {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      const unsignedTx = yield (0, _properties.resolveProperties)(transaction);
      const serializedTx = (0, _transactions.serialize)(unsignedTx);
      const transactionSignature = yield _this4._signDigest((0, _keccak.keccak256)(serializedTx));
      return (0, _transactions.serialize)(unsignedTx, transactionSignature);
    })();
  }
  connect(provider) {
    return new AwsKmsSigner(this.kmsCredentials, provider);
  }
}
exports.AwsKmsSigner = AwsKmsSigner;